const documents = [
  {
    title: "Anunț privind acordarea tichetelor sociale pe suport electronic",
    file: "Anunț privind acordarea Tichetelor sociale pe suport electronic.pdf",
    action: "view",
  },
  {
    title: "Cerere tichete sociale – 2026–2027",
    file: "Cerere tichete sociale - 2026-2027.docx",
    action: "download",
  },
];

export default function TicheteSocialePage() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* TITLU */}
        <div className="text-center">
          <h1 className="text-xl font-bold">
            Liceul Tehnologic „Dr. Florian Ulmeanu” Ulmeni
          </h1>

          <h1 className="text-xl font-semibold mt-2">
            ANUNȚ
          </h1>

          <h2 className="text-lg font-semibold">
            privind acordarea tichetelor sociale pe suport electronic pentru
            sprijin educațional
          </h2>
        </div>

        {/* CONTINUT */}
        <div className="bg-white p-6 rounded shadow space-y-4 text-justify text-sm leading-relaxed">
          {/* DOCUMENTELE NOI */}
          <div className="space-y-3">
            {documents.map((document) => {
              const documentUrl = `/educatie/ticheteSociale/${encodeURIComponent(
                document.file
              )}`;

              return (
                <div
                  key={document.file}
                  className="flex flex-col gap-3 border rounded-md p-4 sm:flex-row sm:items-center sm:justify-between"
                >
                  <span className="font-medium text-gray-800">
                    {document.title}
                  </span>

                  {document.action === "view" ? (
                    <a
                      href={documentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block rounded bg-blue-600 px-4 py-2 text-center text-white hover:bg-blue-700"
                    >
                      Deschide PDF
                    </a>
                  ) : (
                    <a
                      href={documentUrl}
                      download
                      className="inline-block rounded bg-green-600 px-4 py-2 text-center text-white hover:bg-green-700"
                    >
                      Descarcă cererea
                    </a>
                  )}
                </div>
              );
            })}
          </div>

          {/* FRAME-URILE EXISTENTE */}
          <div className="flex justify-center">
            <iframe
              src="/educatie/ticheteSociale/Afiș Tichete sociale.pdf"
              title="Afiș tichete sociale"
              className="w-full h-[90vh] border rounded"
            ></iframe>
          </div>

          {/* PDF */}
          <div className="flex justify-center">
            <iframe
              src="/educatie/ticheteSociale/Tichete%20sociale.pdf"
              title="Tichete sociale"
              className="w-full h-[90vh] border rounded"
            ></iframe>
          </div>
        </div>
      </main>
    </div>
  );
}